import { HttpHandler, HttpInterceptor, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

import { AuthService } from '../services/auth.service';
import { catchError, tap } from 'rxjs/operators';

import swal from 'sweetalert2';

import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if ( String(req.url).includes('partica.online') ) {
            const partica_token = atob(localStorage.getItem('PARTICA_TOKEN'));
            const headers = req.headers.set('Authorization', 'Bearer ' + partica_token);

            const newReq = req.clone({
                headers: headers
            });

            return next.handle(newReq).takeUntil(this.authService.cancelHttp);
        } else {
            const _token = this.authService.getToken();
            const _md_token = this.authService.getMDToken();
            const md_authorization = req.headers.get('MD-Authorization');

            let headers = req.headers.set('Authorization', 'Bearer ' + _token);

            if (!md_authorization && _md_token) {
                headers = headers.set('MD-Authorization', _md_token);
            }

            if (typeof _token !== 'undefined' && _token !== null) {
                const newReq = req.clone({
                    headers: headers
                });

                return next.handle(newReq).pipe(
                        tap( (event: any) => {
                            if ( event instanceof HttpResponse) {
                                return event;
                            }
                        }),
                        catchError((error: any) => {
                            if ( error instanceof HttpErrorResponse ) {
                                let message = 'Please try again later or try refreshing the page.';

                                if (typeof error.error !== 'undefined' && typeof error.error.message !== 'undefined') {
                                    message = error.error.message;
                                }

                                if ( error.status === 401 ) {
                                    swal({
                                        position: 'top-right',
                                        type: 'error',
                                        title: 'Unauthorized Access',
                                        showConfirmButton: false,
                                        allowOutsideClick: false
                                    });

                                    setTimeout(() => {
                                        window.location.href = '/login';
                                    }, 1000);
                                } else {
                                    swal({
                                        position: 'top-right',
                                        type: 'error',
                                        title: 'API Error',
                                        text: message,
                                        showConfirmButton: false,
                                        allowOutsideClick: false
                                    });
                                }
                            }
                            if ( environment.production ) {
                                $.ajax({
                                    url: environment.slackWebHook,
                                    // tslint:disable-next-line:max-line-length
                                    data: `{"text": "\`URL: ${req.url}\` \`\`\`${error.message}\`\`\` \n BODY: \`\`\`${encodeURIComponent(JSON.stringify(req.body))}\`\`\`"}`,
                                    type: 'POST'
                                });
                            }
                            return error;
                        })
                    );
            }
        }

        return next.handle(req);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth.interceptor.ts